import SplashScreen from "components/SplashScreen";
import { Backdrop } from "@material-ui/core";
import { useSelector } from "react-redux";

const CustomBackdrop = () => {
	const resultProps = useSelector((state) => ({
		walletPhase1: state?.walletRequestStepTwo?.isLoading?.backdrop,
		walletPhase2: state?.walletRequestStepTwo?.isLoading?.backdrop,
		transaction: state?.transaction?.isLoading?.backdrop,
		stores: state?.stores?.isLoading?.backdrop,
		storeSlice: state?.storeSlice?.isLoading?.backdrop,
		login: state?.login?.isLoading?.backdrop,
		general: state?.backdrop?.isLoading?.backdrop,
	}));

	return (
		<Backdrop open={Object.values(resultProps).some((item) => item)} style={{ zIndex: 99999 }}>
			<SplashScreen />
		</Backdrop>
	);
};

export default CustomBackdrop;
